<template>
  <div>
    <!-- CUENTA VIEW/EDIT -->
    <cuenta-navigation-drawer />
    <!-- CUENTA SELECTOR -->
    <cuentas-select
      v-if="defaultable"
    ></cuentas-select>
    <cuentas-selected
      v-else
    ></cuentas-selected>
    <cerradas-filter
      v-if="defaultable"
    ></cerradas-filter>
    <v-divider class="py-1"></v-divider>
    <div v-show="isSelected">
      <!--
      <cuentas-operaciones></cuentas-operaciones>
      <v-divider></v-divider>
      -->
      <transacciones-filters />
      
      <v-tabs
        v-model="tab"
        color="primary"
        grow
      >
        <v-tab class="font-weight-bold">
          <v-icon left size="20">mdi-format-list-bulleted</v-icon>
          Transacciones
        </v-tab>
        <v-tab class="font-weight-bold">
          <v-icon left size="20">mdi-link-variant</v-icon>
          Imputaciones
        </v-tab>
      </v-tabs>

      <v-tabs-items v-model="tab" class="my-1">
        <v-tab-item>
          <transacciones-datatable></transacciones-datatable>
        </v-tab-item>
        <v-tab-item>
          <imputaciones-datatable></imputaciones-datatable>
        </v-tab-item>
      </v-tabs-items>
      <v-divider class="my-4"></v-divider>
    </div>
    <div v-show="!isSelected">
      <v-skeleton-loader
        v-bind="attrs"
        type="table"
      ></v-skeleton-loader>
    </div>
    <cuentas-listener></cuentas-listener>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import NavigationComponent from '@/pages/cuentas/NavigationComponent'
import TransaccionesDatatable from '@/pages/transacciones/DatatableComponent'
import ImputacionesDatatable from '@/pages/imputaciones/DatatableComponent'
import CuentasSelect from '@/pages/cuentas/SelectComponent'
import CuentasSelected from '@/pages/cuentas/SelectedComponent'
import CuentasListener from '@/pages/cuentas/ListenerComponent'
import TransaccionesFilters from '@/pages/transacciones/FiltersComponent'
import CuentasOperaciones from '@/pages/cuentas/OperacionesComponent'
import CerradasFilter from '@/pages/cuentas/CerradasFilterComponent'

export default {
  name: 'CuentasMainComponent',
  components: {
    'cuenta-navigation-drawer': NavigationComponent,
    'cuentas-select': CuentasSelect,
    'cuentas-selected': CuentasSelected,
    'cerradas-filter': CerradasFilter,
    'cuentas-listener': CuentasListener,
    'transacciones-datatable': TransaccionesDatatable,
    'imputaciones-datatable': ImputacionesDatatable,
    'transacciones-filters': TransaccionesFilters,
    'cuentas-operaciones': CuentasOperaciones
  },
  data () {
    return {
      attrs: {
        boilerplate: true,
        elevation: 2,
      },
      tab: 0,
    }
  },
  mounted() {
    // window.addEventListener('keydown', this.handleKeyboard);
  },
  beforeDestroy() {
    // window.removeEventListener('keydown', this.handleKeyboard);
  },
  created () {
    //
  },
  computed: {
    ...mapGetters('Cuentas', ['selected', 'defaultable']),
    isSelected () {
      return this.selected && this.selected.id > 0
    },
  },
  methods: {
    onSaldoSelected () {
      this.$store.dispatch('Transacciones/onFetch');
      this.tab = 1
    },
    handleKeyboard(event) {
      //
    }
  }
}
</script>

